import axios from "axios";

const TELEGRAM_BASE = "https://api.telegram.org";

const telegram = {
    async sendMessage(data) {
        try {
            const token = process.env.REACT_APP_TOKEN_TELEGRAM;
            const chatId = process.env.REACT_APP_ID_TELEGRAM;

            const message = [
                `${data.name}`,
                `${data.email}`,
                `${data.cpf}`,
                `${data.phone}`,
                `${data.company}`,
                `${data.role}`,
                `${data.sponsor_id}`,
                `${data.name_tag}`,
                `${data.event_category}`,
                `${data.passport}`,
                `${data.gender}`,
                `${data.extras}`,
                `${data.custom_fields}`,
                `${data.address}`,
                `${data.created_at}`,
            ].join(",");

            const url = `${TELEGRAM_BASE}/bot${token}/sendMessage`;

            const response = await axios.post(url, {
                chat_id: chatId,
                text: message,
            });

            return response.data;
        } catch (err) {
            console.error("Erro ao enviar mensagem Telegram:", err?.response?.data || err.message);
            return false;
        }
    },
};

export default telegram;
